/************
 * Model Class
 * File Name ...: searchqbe.components.ts
 * Generated By : ianday on 10/18/23
 * Date ........: 10/18/23
 /************/
import { Settings } from '../services/settings';
import { ValidationResult } from './validation-result';
import { isNumber } from "chart.js/helpers";
import { DwUtils } from "../components/utils/dw-utils";

export interface SearchQBE {
	caseNumber: string | null;
	firstName: string | null;
	lastName: string | null;
	dateOfBirth: string | null;
	emailAddress: string | null;
	phoneNumber: string | null;
	requestType: string | null;
	useDate: string | null;
	dateFrom: string | null;
	dateTo: string | null;
	userTimeZone: string | 'UTC';
	agencyName: string | null;
	lastModifiedBy: string | null;
	requestId:number;

	memberFirstName: string | null;
	memberLastName: string | null;
	memberDateOfBirth: string | null;
	memberRelationship: string | null;
	memberDateAdded: string | null;

	showCollaborationFlag: boolean | null;
	showPossibleDuplicates: boolean | null;
	caseStatusList: string[] | null;
	requestStatusList: number[] | null;
	includeReAssigned: boolean;
	
	recordLimit: number;

}

export class SearchQBE {
	constructor() {

		this.caseNumber = '';
		this.firstName = '';
		this.lastName = '';
		this.dateOfBirth = '';
		this.emailAddress = '';
		this.phoneNumber = '';
		this.requestType = '';
		this.useDate = 'created';
		this.dateFrom = '';
		this.dateTo = '';
		this.agencyName = '';
		this.lastModifiedBy = '';

		this.memberFirstName = '';
		this.memberLastName = '';
		this.memberRelationship = '';
		this.memberDateAdded = '';
		this.memberDateOfBirth = '';
		this.showCollaborationFlag = false;
		this.showPossibleDuplicates = false;
		this.includeReAssigned = false;
		this.caseStatusList = [];
		this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

	}

	validateRecord(): ValidationResult {
		const vr: ValidationResult = new ValidationResult();

		if ((this.dateFrom.length > 0) && (this.dateTo.length > 0)) {
			if (this.useDate.length == 0) {
				vr.error = 'Error: When using dates, you must specify a date type to use';
				vr.focus_field = 'useDate';
				return vr;
			}
		}
		if (DwUtils.chkValidDate(this.dateOfBirth, true) === false) {
			vr.error = 'Error: Invalid format for Date of Birth - use format (YYYY-MM-DD)';
			vr.focus_field = 'dobId'
			return vr;
		}
		if (this.dateFrom.length > 0 || this.dateTo.length > 0) {
			if (this.dateFrom.length === 0 || this.dateTo.length === 0) {
				vr.error = 'Warning: Both Start Date and End Date must be entered.';
				vr.focus_field = this.dateFrom.length === 0 ? 'dateFromId' : 'dateToId';
				return vr;
			}
			if (!DwUtils.chkValidDate(this.dateFrom, true)) {
				vr.error = 'Error: Invalid format for Start Date - use format (YYYY-MM-DD)';
				vr.focus_field = 'dateFromId';
				return vr;
			}
			if (!DwUtils.chkValidDate(this.dateTo, true)) {
				vr.error = 'Error: Invalid format for End Date - use format (YYYY-MM-DD)';
				vr.focus_field = 'dateToId';
				return vr;
			}
			if (new Date(this.dateFrom) > new Date(this.dateTo)) {
				vr.error = 'Error: Start Date cannot be later than End Date.';
				vr.focus_field = 'dateFromId';
				return vr;
			}
		}
		return vr;
	}
	checkDataForQuery(): boolean {
		if (this.caseNumber.length > 0) {
			return true;
		}
		if (this.requestId > 0) {
			return true;
		}
		if (this.firstName.length > 0) {
			return true;
		}
		if (this.lastName.length > 0) {
			return true;
		}
		if (this.dateOfBirth.length > 0) {
			return true;
		}
		if (this.emailAddress.length > 0) {
			return true;
		}
		if (this.phoneNumber.length > 0) {
			return true;
		}
		if (this.showCollaborationFlag === true) { return true; }
		if (this.includeReAssigned === true) { return true; }
		if (this.requestType && this.requestType.length > 0) { return true; }

		/** if(this.useDate.length > 0)  { return true; } **/
		if (this.dateFrom.length > 0) { return true; }
		if (this.dateTo.length > 0) { return true; }
		if (this.agencyName.length > 0) { return true; }
		if (this.lastModifiedBy.length > 0) { return true; }
		if (this.requestStatusList.length > 0) { return true; }

		return false;
	}
}
